import React, { useEffect, useState } from 'react';
import { RefreshCw } from 'lucide-react';
import { waApi } from './waApi';

const tone = (a) => a?.startsWith('REPORT') ? 'text-sky-300' : a === 'UNLINKED' || a === 'DISABLED' ? 'text-rose-300'
  : a === 'WA_PRODUCTION_PLAN' || a === 'AI_CREATE_ORDER' || a === 'AI_FG_STOCK' ? 'text-emerald-300' : 'text-zinc-400';

export const WaMessageLog = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const load = async () => { setLoading(true); try { const r = await waApi.messages(null, 120); setRows([...r.messages].reverse()); } finally { setLoading(false); } };
  useEffect(() => { load(); }, []);
  return (
    <div className="bg-zinc-900 border border-zinc-800 rounded-2xl overflow-hidden" data-testid="wa-message-log">
      <div className="flex items-center justify-between px-4 py-3 border-b border-zinc-800">
        <div className="text-sm font-semibold text-zinc-100">Message log <span className="text-zinc-500 font-normal text-xs">· last {rows.length}</span></div>
        <button onClick={load} data-testid="wa-log-refresh" className="text-zinc-400 hover:text-zinc-100"><RefreshCw size={14} className={loading ? 'animate-spin' : ''} /></button>
      </div>
      <div className="max-h-[560px] overflow-y-auto divide-y divide-zinc-800/60">
        {rows.length === 0 && <div className="text-xs text-zinc-500 text-center py-12">No WhatsApp traffic yet.</div>}
        {rows.map(m => (
          <div key={m.id} className="px-4 py-2.5 text-xs grid grid-cols-[90px_120px_1fr] gap-3 items-start" data-testid="wa-log-row">
            <div className="text-zinc-500">{new Date(m.ts).toLocaleString('en-IN', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })}</div>
            <div>
              <div className="text-zinc-200 truncate">{m.direction === 'in' ? '→ ' : '← '}{m.user_name || m.phone || 'unknown'}</div>
              <div className={`text-[10px] ${tone(m.action)}`}>{m.action || (m.direction === 'in' ? 'inbound' : 'reply')}{m.delivery?.simulated ? ' · sim' : m.delivery?.ok === false ? ` · FAILED${m.delivery?.error ? ' — ' + m.delivery.error : ''}` : m.delivery?.status ? ` · ${m.delivery.status}` : ''}</div>
            </div>
            <div className="text-zinc-300 whitespace-pre-wrap line-clamp-4">{m.text}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
